/**
 * 展示维度 icon 纯函数。
 */

import { SHOW_DIMENSION_ICON } from './constants';
import { SHOW_DIMENSION_ICON_MAP } from './config';
import {
  DimensionIconCategory,
  type IDimensionTrendIconIconfontEntry,
  type IDimensionTrendIconMeta,
} from './types';

const DIMENSION_ICON_KEY_ALIASES: Record<string, string> = {
  china: 'cn',
};

export function isDimensionTrendIconIconfont(
  meta: IDimensionTrendIconMeta,
): meta is IDimensionTrendIconIconfontEntry {
  return (
    'iconfontType' in meta &&
    typeof (meta as IDimensionTrendIconIconfontEntry).iconfontType === 'string'
  );
}

/**
 * 将任意大小写的 icon key 规范为 SHOW_DIMENSION_ICON_MAP 的 canonical key。
 *
 * @core 配置写入与展示读取须同一 key；放 DimensionMapSetModal 内无法被 dimensionIconPickerSearch 复用。
 */
export function normalizeDimensionIconKey(raw?: string): string {
  if (!raw || typeof raw !== 'string') {
    return '';
  }
  const trimmed = raw.trim();
  let candidate = trimmed.toLowerCase();
  const aliased = DIMENSION_ICON_KEY_ALIASES[candidate];
  if (aliased) {
    candidate = aliased;
  }
  const keys = Object.keys(SHOW_DIMENSION_ICON_MAP);
  const exact = keys.find(k => k === trimmed || k === candidate);
  if (exact) {
    return exact;
  }
  return keys.find(k => k.toLowerCase() === candidate) || candidate;
}

/**
 * 分维度卡片榜单：平台类 icon 沿用品牌色（key 已 normalize）。
 *
 * @core DimNumberTrendCard 榜单条着色与 SHOW_DIMENSION_ICON_COLOR 对齐。
 */
export const SHOW_DIMENSION_PLATFORM_COLOR_KEYS = SHOW_DIMENSION_ICON[
  DimensionIconCategory.Platform
].map(k => normalizeDimensionIconKey(k)) as readonly string[];
